"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**************************************** PROJECT MODULES *****************************************/
var javelin_exports_1 = require("../../javelin-exports");
/********************************* EXPORT DATA WITH TYPES APPLIED *********************************/
/**
 * Object for dealing with Gender data
 *
 * String props:
 *     MALE, FEMALE, BOTH: map to corresponding number Javelin uses
 *
 * Methods:
 *     isRightGender: Check if given gender (from gender object being checked)
 *                    correct for given record gender (true if objectGender is
 *                    BOTH or both genders match)
 *
 *     toString: Get gender name from given gender number
 */
exports.Gender = javelin_exports_1.javelin.data.model.Gender;
//# sourceMappingURL=gender.js.map